import { isArray, isObject, isNull, isSerializablePrimitive } from 'isntnt';
export const keys = Object.keys;
export const createEmptyObject = () => Object.create(null);
export var HTTPRequestMethod;
(function (HTTPRequestMethod) {
    HTTPRequestMethod["GET"] = "GET";
    HTTPRequestMethod["POST"] = "POST";
    HTTPRequestMethod["PATCH"] = "PATCH";
    HTTPRequestMethod["DELETE"] = "DELETE";
})(HTTPRequestMethod || (HTTPRequestMethod = {}));
export const createDataValue = (data) => {
    if (isArray(data)) {
        return data.map(createDataValue);
    }
    else if (isObject(data)) {
        const target = createEmptyObject();
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const value = createDataValue(data[key]);
                // Omit values that are not data values
                if (isNull(data[key]) || !isNull(value)) {
                    ;
                    target[key] = createDataValue(data[key]);
                }
            }
        }
        return target;
    }
    if (isSerializablePrimitive(data)) {
        return data;
    }
    return null;
};
//# sourceMappingURL=data.js.map